export default __webpack_public_path__ + "static/newsframe-772c2976975f15c08b20a03f3f5794e3.png";